import { ValueOf } from '../utilities/types';

const timePeriods = {
  DAYS: 'days',
  MONTHS: 'months',
  YEARS: 'years',
} as const;

const timePeriodLabels = {
  [timePeriods.DAYS]: 'days',
  [timePeriods.MONTHS]: 'months',
  [timePeriods.YEARS]: 'years',
} as const;

export type TimePeriods = ValueOf<typeof timePeriods>;

export const timePeriodChoices = [
  {
    id: timePeriods.DAYS,
    name: timePeriodLabels[timePeriods.DAYS],
  },
  {
    id: timePeriods.MONTHS,
    name: timePeriodLabels[timePeriods.MONTHS],
  },
  {
    id: timePeriods.YEARS,
    name: timePeriodLabels[timePeriods.YEARS],
  },
];

// Units for windows measured in hours rather than months, e.g. the MultipleIpCountries lookback.
export const shortTimePeriodChoices = [
  { id: 'minutes', name: 'minutes' },
  { id: 'hours', name: 'hours' },
  { id: timePeriods.DAYS, name: timePeriodLabels[timePeriods.DAYS] },
];

export default timePeriods;
